import React, {useState, useEffect} from "react"
import {useNavigate} from "react-router-dom"

export default function DesktopSearch() {
  const [query, setQuery] = useState("")
  const [windowWidth, setWindowWidth] = useState(window.innerWidth) // Track window width
  const navigate = useNavigate()

  useEffect(() => {
    // Function to handle window resize event
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    // Add event listener for window resize
    window.addEventListener("resize", handleResize)

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, []) // Empty dependency array means this effect runs once when the component mounts

  const handleSearch = () => {
    if (query.trim()) {
      navigate(`/search?query=${encodeURIComponent(query)}`)
      setQuery("") // Clear the query after searching
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch()
    }
  }

  const containerStyle = {
    width: windowWidth <= 768 ? "75%" : "100%",
    padding: windowWidth <= 768 ? "0 0.2rem" : "0 0.2rem",
    marginTop: windowWidth <= 768 ? "4.5rem" : "0",
    margin: windowWidth <= 768 ? "0px" : "0 auto",
  }

  return (
    <div style={containerStyle}>
      <div style={{display: "flex", gap: "4px", alignItems: "center"}}>
        <input
          type="text"
          placeholder="Haber..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          style={{
            flex: 1,
            padding: "0.4rem 0.6rem",
            borderRadius: "4px",
            border: "1px solid #ddd",
          }}
        />
        <button
          onClick={handleSearch}
          style={{
            padding: "0.4rem 0.8rem",
            fontSize: "0.9rem",
            backgroundColor: "#ff0000",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Ara
        </button>
      </div>
    </div>
  )
}
